import { render, staticRenderFns } from "./WLReferralMain.vue?vue&type=template&id=6bb31012&scoped=true&"
import script from "./WLReferralMain.vue?vue&type=script&lang=ts&"
export * from "./WLReferralMain.vue?vue&type=script&lang=ts&"
import style0 from "./WLReferralMain.vue?vue&type=style&index=0&id=6bb31012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb31012",
  null
  
)

export default component.exports